import React from "react";
import { FaHeadset, FaLifeRing, FaScrewdriverWrench } from "react-icons/fa6";
import motor from "../assets/banner5.jpg";

export default function MotorRewinding() {
  const features = [
    {
      icon: <FaHeadset size={20} className="text-primary" />,
      text: "Responsive support for day-to-day issues that affect system use, continuity, and staff productivity.",
    },
    {
      icon: <FaScrewdriverWrench size={20} className="text-primary" />,
      text: "Preventive maintenance and configuration support that helps technology environments stay dependable.",
    },
    {
      icon: <FaLifeRing size={20} className="text-primary" />,
      text: "A support mindset centered on practical fixes, continuity, and long-term improvement.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">IT Support & Maintenance</h2>
          <p className="section-copy">
            Nova Technologies helps clients protect uptime and confidence through reliable
            support and proactive system care.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={motor} alt="IT Support and Maintenance" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Support and maintenance services are designed to keep digital operations moving
            smoothly. The emphasis is on dependable assistance, practical issue resolution,
            and continuous system readiness over time.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Assess recurring issues, support pressure points, and system health.</li>
            <li>Define maintenance priorities and practical response paths.</li>
            <li>Deliver support interventions and reliability improvements.</li>
            <li>Review patterns and refine the support model over time.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
